/** Pure list helpers for «Rutiner per ansatt» (kept out of the pages so they are cheap to test). */

export const EMPLOYEE_FILTERS = ["all", "overdue", "pending", "missing"];

/** Pure filter for the employee list (unit tested). */
export const filterComplianceEmployees = (rows = [], { query = "", filter = "all" } = {}) => {
  const needle = query.trim().toLowerCase();
  return rows.filter((row) => {
    if (needle && !`${row.name || ""} ${row.email || ""} ${row.position || ""}`.toLowerCase().includes(needle)) return false;
    if (filter === "overdue") return row.overdue_count > 0;
    if (filter === "pending") return row.pending_count > 0;
    if (filter === "missing") return row.without_access_count > 0;
    return true;
  });
};

export const ROUTINE_FILTERS = ["all", "no_access", "pending", "overdue", "acknowledged"];

/** Filter + group routines by chapter (pure, unit tested). */
export const groupEmployeeRoutines = (documents = [], { query = "", filter = "all", ungrouped = "Uten kapittel" } = {}) => {
  const needle = query.trim().toLowerCase();
  const visible = documents.filter((doc) => {
    if (needle && !`${doc.document_number || ""} ${doc.title || ""}`.toLowerCase().includes(needle)) return false;
    if (filter === "all") return true;
    if (filter === "pending") return doc.status === "pending";
    return doc.status === filter;
  });
  const groups = new Map();
  visible.forEach((doc) => {
    const key = doc.chapter ? `${doc.chapter.number || ""} ${doc.chapter.title || ""}`.trim() : ungrouped;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(doc);
  });
  return [...groups.entries()].map(([label, docs]) => ({ label, documents: docs }));
};

